export default __webpack_public_path__ + "static/media/empty_image_profile.449641a1.svg";